module.exports = __webpack_public_path__ + "img/template_private_icon.440a5ad3.svg";